'use client';

export function GridLines() {
  return (
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute left-1/3 top-0 bottom-0 w-px bg-white opacity-30" />
      <div className="absolute left-2/3 top-0 bottom-0 w-px bg-white opacity-30" />
      <div className="absolute top-1/3 left-0 right-0 h-px bg-white opacity-30" />
      <div className="absolute top-2/3 left-0 right-0 h-px bg-white opacity-30" />
    </div>
  );
}
